import React, { useMemo } from "react";
import { useAuth } from "../../../context/AuthContext";
import CertificatePreview from "../../../components/common/CertificatePreview";
import { premiumRequest } from "../../../services/Premium";

/** Ten sam podgląd co w kroku 5 zwykłego wniosku, z API zleceń Premium. */
export default function OrderCertificatePreview({
  orderId,
  revision,
  onReadyChange,
}) {
  const { accessToken } = useAuth();
  const documentSource = useMemo(() => {
    const pages = new Map();
    const path = `/orders/${orderId}/preview`;
    return {
      loadPage: async ({ page, useCache, signal }) => {
        if (!useCache) pages.clear();
        if (pages.has(page)) return pages.get(page);
        const result = await premiumRequest(
          accessToken,
          `${path}/pages/${page + 1}`,
          {
            method: "POST",
            data: { revision },
            signal,
          },
        );
        const image = {
          blob: new Blob(
            [Uint8Array.from(atob(result.image), (char) => char.charCodeAt(0))],
            {
              type: "image/png",
            },
          ),
          pageCount: result.pageCount,
        };
        if (!signal.aborted) pages.set(page, image);
        return image;
      },
      download: async () => {
        const blob = await premiumRequest(accessToken, path, {
          method: "POST",
          data: { revision },
          responseType: "blob",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Podgląd świadectwa.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        // Przeglądarka musi zdążyć rozpocząć pobieranie przed zwolnieniem adresu.
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      },
      downloadLabel: "Pobierz podgląd PDF",
    };
  }, [accessToken, orderId, revision]);
  return (
    <section
      className="card premium-panel premium-certificate-preview"
      aria-label="Podgląd świadectwa PDF"
    >
      <CertificatePreview
        documentSource={documentSource}
        onSuccess={() => onReadyChange(true)}
        onFailure={() => onReadyChange(false)}
        setIsDocumentRefreshing={(refreshing) => {
          if (refreshing) onReadyChange(false);
        }}
      />
    </section>
  );
}
